const apiUrl = process.env.REACT_APP_API_URL;

export async function DeleteProblemaRecompensa(idProblema: string, idRecompensa: string, origenTipo?: string) {
    const query = origenTipo ? `?origen_tipo=${encodeURIComponent(origenTipo)}` : '';
    const url = `${apiUrl}:8061/jutge/problema/${idProblema}/recompenses/${idRecompensa}${query}`;
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        if (!response.ok) return false;
        return true;
    } catch (e) {
        return false;
    }
}
